const socketUrl = "wss://sahmed.ca/ba-socket";
export default socketUrl;